export default "__VITE_ASSET__Bnjm$v7t__"